import { Accordion, AccordionItem, Button } from '@heroui/react';
import { Navigate, useNavigate } from 'react-router';

import { useGetPatientQuery } from '@/patient-app-common/api/patientApi';

import { DemoDates } from './DemoDates';
import { DemoProfile } from './DemoProfile';
import { DemoSurveys } from './DemoSurveys';

export function Demo() {
  const { data: patient } = useGetPatientQuery();
  const navigate = useNavigate();

  if (!patient?.demo) {
    console.log('Patient demo?: ', patient?.demo);
    return <Navigate to="/" replace />;
  }

  return (
    <div className="w-full lg:w-3/4 mx-auto space-y-4 py-12">
      <div className="flex items-center justify-between gap-4 mb-4">
        <h1 className="text-2xl">Demo Controls</h1>
        <Button
          color="primary"
          size="md"
          variant="bordered"
          onPress={() => {
            navigate('/home');
          }}
        >
          Back
        </Button>
      </div>
      <Accordion defaultExpandedKeys={['date']} selectionMode="multiple">
        <AccordionItem className="px-4" key="date" title="Program Dates">
          <DemoDates patient={patient} />
        </AccordionItem>
        <AccordionItem className="px-4" key="survey" title="Surveys">
          <DemoSurveys surveys={patient.surveys} />
        </AccordionItem>
        <AccordionItem className="px-4" key="profile" title="Patient Profile">
          <DemoProfile initProfile={patient.profile} />
        </AccordionItem>
      </Accordion>
    </div>
  );
}
